import React, { Component } from "react";
import { ContractFinance } from "@eres/ejari-api/Entity/contract";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import Strings from "@my-dld/assets/strings";
import FormRow from "@eres/forms-web/FormRow";
import CurrencyInputField, { Props as CFProps } from "@eres/forms-web/CurrencyInputField";
import FormSubSection from "@eres/forms-web/FormSubSection";

interface Props {
	data: ContractFinance;
}

interface State extends ContractFinance {
}

class ContractCalculatedValue extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			...props.data
		};
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
			errorManager: defaultErrorManager,
		};
		return (
			<FormSubSection title={ Strings.calculated_value }>
				<FormRow { ...filedProps }>
					<CurrencyInputField
						textRenderer={ valueRenderer }
						mode={ "text" }
						id={ "ContractAnnualValue" }
						label={ Strings.annual_rent }/>
					<CurrencyInputField
						textRenderer={ valueRenderer }
						mode={ "text" }
						id={ "ContractActualAnnualValue" }
						label={ Strings.actual_annual_rent }/>
					<CurrencyInputField
						textRenderer={ valueRenderer }
						mode={ "text" }
						id={ "ContractValue" }
						label={ Strings.contract_value }/>
					<CurrencyInputField
						textRenderer={ valueRenderer }
						mode={ "text" }
						id={ "ContractActualValue" }
						label={ Strings.actual_contract_value }/>

				</FormRow>
			</FormSubSection>
		);
	}
}

export default ContractCalculatedValue;

export const valueRenderer = ( props: CFProps, value?: string ) => {
	return <div className="form-control readonly"><strong>{ value } { props.suffix }</strong></div>;
};
